import { render, staticRenderFns } from "./TaskTypeName.vue?vue&type=template&id=51afc9ee&scoped=true&"
import script from "./TaskTypeName.vue?vue&type=script&lang=js&"
export * from "./TaskTypeName.vue?vue&type=script&lang=js&"
import style0 from "./TaskTypeName.vue?vue&type=style&index=0&id=51afc9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51afc9ee",
  null
  
)

export default component.exports